import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';

Vue.use(VueAxios, axios);

axios.defaults.baseURL =
  process.env.NODE_ENV === 'production'
    // ? '//admin.hspcc.co.kr' // 운영
    // : '//admin.hspcc.co.kr'; // 개발
    ? '//admin.kop.co.kr' // 운영
    : '//admin.kop.co.kr'; // 개발


// //192.168.0.60:8080 
// //admin.hspcc.co.kr